// extracted by mini-css-extract-plugin
module.exports = {"itemHolderLeft":"DetailsPopup_itemHolderLeft__3M7z8","itemHolderRight":"DetailsPopup_itemHolderRight__23m6e"};